const registerAttendanceReducerInitialState = {
    isUserInWorkPlace :false,
    attendaceLogs:[]
};

export default (state = registerAttendanceReducerInitialState , action) => {
    debugger;
    switch(action.type){
        case "APP_LOADING":
            return{
                ...state,
                isLoading:action.isLoading
            };
        case "ADD_ATTENDANCE_LOGS":
            return{
               ...state,
               attendaceLogs:[...state.attendaceLogs, ...action.attendanceLogs]
            }
        case "CLEAR_ATTENDANCE_LOGS":
            return{
                ...state,
                attendaceLogs:[]
            }
        case "ADD_ATTENDANCE_LOG":
            return{
                ...state,
                attendaceLogs:[ action.attendanceLog ,...state.attendaceLogs]
             }
        case "ADD_USER_WORKPLACE":
            return{
                ...state,
                userWorkplaces:action.userWorkplace
            }
        case "USER_IN_WORKPLACE":
            return{
                ...state,
                isUserInWorkPlace:action.userInWorkplace,
                userWorkplace:action.userWorkplace
            }
        default :
            return state;
    }

}